/* Night-page motion for bare listicles. Hero drifts like a long minute at
   23:40. Other photos lift the crop as they enter, then sit still. Without
   this file the images stay fully visible. Reduced-motion skips all of it. */
(function () {
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

  var hero = document.querySelector(".ease-listicle-bare .listicle-hero__media img");
  if (hero) hero.classList.add("li-hero-drift");

  var shots = document.querySelectorAll(
    ".ease-listicle-bare .listicle-intro__img, " +
      ".ease-listicle-bare .listicle-reasons__img, " +
      ".ease-listicle-bare .listicle-final-cta__media img"
  );
  if (!shots.length || !("IntersectionObserver" in window)) return;

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add("is-in");
        io.unobserve(entry.target);
      });
    },
    { threshold: 0.18, rootMargin: "0px 0px -6% 0px" }
  );

  var vh = window.innerHeight || 1;
  shots.forEach(function (img) {
    var rect = img.getBoundingClientRect();
    if (rect.top < vh * 0.92 && rect.bottom > 40) {
      return;
    }
    img.classList.add("li-reveal");
    io.observe(img);
  });
})();
